import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import CentredContentContainer from "../Widgets/CentredContentContainer"
import Advert from "./Advert"
import theme from "../../styles/theme"

class DoubleAdvertBannerSlice extends PureComponent {
  render() {
    const { classes, item } = this.props;
    const { items, heading } = item;
    return (
      <CentredContentContainer>
        <section className={classes.section}>
        { heading && <h6 className={classes.heading}>{ heading }</h6> }
          <div className={classes.wrapper}>
            { items.map((item, i) => (
              <Advert
                key={i}
                image={item.image}
                contentOrder={item.content_order}
                alignCopy={item.text_align}
                title={item.title}
                heading={item.heading}
                text={item.text}
                buttonLink={item.button_link}
                buttonSize="default"
                classNames={classes}
              />
            ))}
          </div>
        </section>
      </CentredContentContainer>
    )
  }
}

export default injectSheet(
  {
    section: {
      borderTop: '1px solid #B0B0B0',
      borderBottom: '1px solid #B0B0B0',
    },
    wrapper: {
      display:'flex',
      padding: ['2rem', 0, '1.5rem'],
      [theme.breakpoint("tablet")]: {
        padding: ['2rem', 0],
      },
      '& > div:first-child': {
        marginRight: 25
      }
    },
    container: {
      flexBasis: '50%',
      borderLeft: 0,
      borderRight: 0,
    },
    content: {
      padding: 0
    },
    imageContainer: {
      padding: [0, 0, 20, 0],
      [theme.breakpoint("tablet")]: {
        padding: [0, 15, 0, 0]
      }
    },
    heading: {
      fontFamily: theme.font.family,
      fontSize: 12,
      color: theme.colors.faintGrey,
      letterSpacing: 0.26,
      textAlign: 'center',
      lineHeight: 1,
      textTransform: 'uppercase',
      margin: ['1rem', 0, 0, 0],
      padding: [0, '2rem'],
    },
  }
)(DoubleAdvertBannerSlice)



// WEBPACK FOOTER //
// ./src/components/Article/DoubleAdvertBannerSlice.js